import { connect } from 'react-redux';
import { resetPassword } from '../../../actions/auth/actionCreators';
import PasswordResetForm from './PasswordResetForm';


const mapStateToProps = (state) => ({
  isLoading: state.auth.resetPasswordRequest,
  errorMessage: state.auth.resetPasswordError
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (id, password, code) => dispatch(resetPassword(id, password, code)),
});

const PasswordResetFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordResetForm);

export default PasswordResetFormContainer;



// WEBPACK FOOTER //
// src/components/login/PasswordResetForm/index.js